<template>
    <cms-block v-bind="$props" @block-selected="selectBlock" :style="blockStyle" no-padding>
        <template v-if="isEditMode">
            <vuedraggable v-if="isSelected" v-model="block.columns" @sort="onColumnsSorted" handle=".drag-handle"
                          class="list-group properties-columns"
                          ghost-class="list-item-ghost" drag-class="list-item-drag" animation="150">
                <simple-list-view-item v-for="(column, index) in block.columns" :key="`properties-col-${index}`" :class="`column-${index}`"
                                       glyph="fa-table-columns" :style="{flex: column.span}">
                    <span class="name mx-auto">{{column.name}}</span>
                    <b-dropdown variant="transparent" toggle-class="rounded-pill" no-caret>
                        <template #button-content>
                            <i class="fas fa-ellipsis"/>
                        </template>
                        <b-dropdown-form>
                            <b-form-group label-cols="4" :label="tr(`Size|Taille`)" class="mb-0">
                                <b-spinbutton v-model.number="column.span"/>
                            </b-form-group>
                        </b-dropdown-form>

                        <b-dropdown-divider/>
                        <b-dropdown-item @click="addColumn(index-1)">
                            <i class="fas fa-table-columns-add-before"/>
                            <span v-tr>Insert column before|Insérer une colonne avant</span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="addColumn(index)">
                            <i class="fas fa-table-columns-add-after"/>
                            <span v-tr>Insert column after|Insérer une colonne après</span>
                        </b-dropdown-item>
                        <b-dropdown-divider/>
                        <e-button-confirm @click="deleteColumn(index)" dropdown-item dropdown-class="text-danger"
                                          confirm-title="Delete?|Supprimer?" button-text="Delete|Supprimer" :icon="getPublicIcon('trash')" :title="'Delete|Supprimer'|tr" v-b-tooltip>
                            <i class="fas fa-trash"/>
                            <span v-tr>Delete|Supprimer</span>
                        </e-button-confirm>
                    </b-dropdown>
                </simple-list-view-item>
            </vuedraggable>
        </template>

        <cms-block-table-row v-for="child in block.children" :key="child.id" @block-selected="selectBlock"
                            :block="child" :parent="block" :block-selection="blockSelection" :editable="editable"/>
    </cms-block>
</template>

<script>
import CmsBlockRenderer from "@components/editor/rendering/blocks/cms-block-renderer.vue";
import CmsBlock from "@/components/editor/rendering/blocks/cms-block.vue";
import CmsBlockTableRow from "@components/editor/rendering/blocks/cms-block-table-row.vue";
import SimpleListViewItem from "@components/editor/properties/simple-list-view-item.vue";
import Vuedraggable from "vuedraggable";
import EButtonConfirm from "@vue-components/components/e-button-confirm.vue";

export default {
    name: `cms-block-table`,
    components: {
        EButtonConfirm,
        SimpleListViewItem, Vuedraggable,
        CmsBlockTableRow,
        CmsBlockRenderer,
        CmsBlock
    },
    extends: CmsBlock,
    computed: {
        blockStyle() {
            let style = {
                "--table-max-columns": this.block.mediaProxy.maxColumns === 0 ? this.block.columns.length : this.block.mediaProxy.maxColumns,
            };
            if (this.block.borders?.active) {
                style[`--block-border-width`] = this.block.borders.mediaProxy.width;
                style[`--block-border-color`] = this.cmsWebsite.getColor(this.block.borders.mediaProxy.color);
                style[`--block-border-style`] = this.block.borders.mediaProxy.style;
            }
            let grid = ``;
            for (let column of this.block.columns) {
                grid += `${column.span}fr `;
            }
            style[`--table-grid-columns`] = grid;
            return style;
        }
    },
    methods: {
        onColumnsSorted(event) {
            this.block.swapColumns(event.oldIndex, event.newIndex);
            this.$forceUpdate();
        },
        addColumn(index) {
            this.block.addColumn(index);
            this.$forceUpdate();
        },
        deleteColumn(index) {
            this.block.deleteColumn(index);
            this.$forceUpdate();
        }
    }
}
</script>

<style lang="scss" scoped>
.cms-block-table {
    --table-max-columns: 1;

    ::v-deep {

        > .cms-container {
            display: table;
            border: none !important;
        }

        .cms-block-table-row {
            > .cms-container {
                display: grid;
                grid-template-columns: var(--table-grid-columns);
                border-block: var(--block-border-width) var(--block-border-style) var(--block-border-color);
                //grid-gap: var(--list-item-spacing);

                .cms-block-table-cell {
                    .cms-container {
                        border-inline: var(--block-border-width) var(--block-border-style) var(--block-border-color);
                    }

                    &:not(:first-child) {
                        > .cms-container {
                            border-left: none;
                        }
                    }
                }
            }

            &:not(:first-child) {
                > .cms-container {
                    border-top: none;
                }
            }
        }

        .cms-block-table-cell {
            display: flex;
            //align-items: center;
            justify-content: center;

            .cms-container {
                display: flex;
                justify-content: center;
                height: 100%;
            }
        }
    }
}

.properties-columns {
    flex-direction: row;
    display: grid;
    grid-template-columns: var(--table-grid-columns);

    > .list-group-item {
        background-color: rgb(219, 234, 254);
        color: rgb(29, 78, 216);
        border: 1px solid rgba(29, 78, 216, 0.3) !important;
        border-radius: 5px;

        &:hover {
            background-color: rgb(182, 214, 244);
        }
    }
}
</style>
